<template>
	<trips-skeleton :hide='true'>
		<div class='a-card' v-for='el in 3' :key='el'>
			<div class='c-card-wrap'>
				<div class='c-card-container'>
					<div class='c-card-image'>
						<span class='skeleton' :style='`width: 100%; height: 100%;`'></span>
					</div>
					<div class='c-card-content'>
						<p class='c-card-title'><span class='skeleton' :style='`width: 184px; height: 22px;`'></span></p>
						<p class='c-card-sub-title'><span class='skeleton' :style='`width: 140px; height: 9px;`'></span></p>
						<div class='c-card-list'>
							<div class='c-card-list-item'>
								<span class='skeleton' :style='`width: 40px; height: 14px;`'></span>
							</div>
							<div class='c-card-list-item'>
								<span class='skeleton' :style='`width: 40px; height: 14px;`'></span>
							</div>
						</div>
						<div class='c-card-list'>
							<div class='c-card-list-item'>
								<span class='skeleton' :style='`width: 75px; height: 14px;`'></span>
							</div>
							<div class='c-card-list-item'>
								<span class='skeleton' :style='`width: 75px; height: 14px;`'></span>
							</div>
						</div>
						<div class='c-card-info'>
							<span class='skeleton' :style='`width: 168px; height: 14px; margin-bottom: 5px`'></span>
							<span class='skeleton' :style='`width: 197px; height: 14px;`'></span>
						</div>
					</div>
				</div>
				<div class='c-card-action'>
					<div class='c-card-action-total'>
						<p class='c-card-total'><span class='skeleton' :style='`width: 130px; height: 25px`'></span></p>
					</div>
					<div class='c-card-action-group-buttons'>
						<span class='skeleton' :style='`width: 100%; height: 47px`'></span>
					</div>
				</div>
			</div>
		</div>
	</trips-skeleton>
</template>

<script>
	import TripsSkeleton from '@/views/account/search/components/skeleton';

	export default {
		components: {
			TripsSkeleton
		}
	}
</script>
